module.exports = __webpack_public_path__ + "img/McKenzG.c32b8491.jpg";